/* Aydınlık / karanlık mod anahtarı.
   Secim localStorage'da saklanir; kullanici hic secim yapmadiysa
   (isletim sistemi karanlik modda olsa bile) tema varsayilan olarak
   aydinlik acilir - sadece kullanici toggle'a basarsa karanlik moda gecer. */

(function () {
  var STORAGE_KEY = 'renneway-theme';

  function currentTheme() {
    try {
      var saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved === 'dark' || saved === 'light') return saved;
    } catch (e) {
      /* gizli sekmede localStorage kapali olabilir */
    }
    return 'light';
  }

  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    document.querySelectorAll('.theme-toggle').forEach(function (button) {
      button.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
    });
  }

  // Sayfa açılır açılmaz uygula ki beyaz parlama olmasın
  applyTheme(currentTheme());

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.theme-toggle');
    if (!button) return;

    event.preventDefault();
    var next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    applyTheme(next);

    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      /* saklanamazsa sadece bu oturumda geçerli olur */
    }
  });
})();
